// ============================================================
// Yol çözümleme
//
// Bir mutasyonun hedefi veri ağacındaki yol ile gösterilir:
//   ["branches", { id: "lefkosa" }, "students", { id: "lf1" }, "note"]
//
// Dizi öğeleri sıra numarasıyla değil kimlikle bulunur — kayıtlar
// yeniden sıralandığında veya araya kayıt girdiğinde yol bozulmasın.
// ============================================================

const cozumle = (kap, adim) => {
  if (adim && typeof adim === "object" && "id" in adim) {
    if (!Array.isArray(kap)) return undefined;
    return kap.find(x => x.id === adim.id);
  }
  return kap?.[adim];
};

// Yolun son adımından önceki kabı döner.
function kapVeAnahtar(kok, yol) {
  let kap = kok;
  for (let i = 0; i < yol.length - 1; i++) {
    kap = cozumle(kap, yol[i]);
    if (kap == null) return [null, null];
  }
  return [kap, yol[yol.length - 1]];
}

export function getAt(kok, yol) {
  return yol.reduce((k, adim) => (k == null ? undefined : cozumle(k, adim)), kok);
}

export function setAt(kok, yol, deger) {
  const [kap, anahtar] = kapVeAnahtar(kok, yol);
  if (kap == null) throw new Error(`Yol çözümlenemedi: ${yolAdi(yol)}`);

  if (anahtar && typeof anahtar === "object" && "id" in anahtar) {
    const hedef = Array.isArray(kap) ? kap.find(x => x.id === anahtar.id) : null;
    // Kayıt bulunamazsa yazmayı reddet. Aksi hâlde dizinin üzerine
    // "[object Object]" anahtarı eklenir ve veri sessizce bozulur.
    if (!hedef) throw new Error(`Kayıt bulunamadı: ${yolAdi(yol)}`);
    Object.assign(hedef, deger);
    return;
  }

  kap[anahtar] = deger;
}

export function pushAt(kok, yol, deger) {
  const dizi = getAt(kok, yol);
  if (!Array.isArray(dizi)) throw new Error(`Dizi değil: ${yolAdi(yol)}`);
  dizi.push(deger);
}

export function deleteAt(kok, yol) {
  const [kap, anahtar] = kapVeAnahtar(kok, yol);
  if (kap == null) return;
  if (anahtar && typeof anahtar === "object" && "id" in anahtar) {
    const i = kap.findIndex(x => x.id === anahtar.id);
    if (i >= 0) kap.splice(i, 1);
  } else {
    delete kap[anahtar];
  }
}

export const yolAdi = yol =>
  yol.map(a => (a && typeof a === "object" ? a.id : a)).join("/");
